<template>
  <vs-popup id="popup-setting-payroll" title="Settings" :active.sync="popupSettingPayroll.isOpen">
    <vs-tabs v-model="active_tab">
      <vs-tab label="Payroll Setting">
        <div class="con-tab-ejemplo pt-base flex flex-col justify-between" style="min-height: inherit">
          <div>
            <h4 class="font-bold text-lg mb-3">Choose period</h4>
            <v-select v-model="selectedPeriod" :options="periodOptions" class="w-full period-select" :clearable="false" :searchable="false"/><br>

            <transition name="list">
              <div v-if="selectedPeriod.id == 4">
                <h4 class="font-bold text-lg mb-3">Number of days</h4>
                <v-select v-model="customDay" :options="customPeriodOptions" class="w-full" :clearable="false" :searchable="false"/><br>
              </div>
            </transition>

            <h4 class="text-lg font-bold mb-3">Choose Start day</h4>
            <datepicker :use-utc="true" v-model="start_date" class="input-schedule" :class="{'has-custom-period': selectedPeriod.id == 4}" :clear-button="true"></datepicker>
          </div>

          <div class="w-2/3 mx-auto">
            <vs-button class="w-full mt-base" @click="savePayrollSetting">Save Setting</vs-button>
          </div>
        </div>
      </vs-tab>

      <vs-tab label="Discount Setting">
        <div class="con-tab-ejemplo pt-base flex flex-col justify-between" style="min-height: inherit">
          <div>
            <h4 class="font-bold text-lg mb-3">Percent for Owner (%)</h4>
            <vs-input v-model="owner_percentage" class="w-full" v-on:keypress="isIntegerNumber($event, 'discount')" />

            <h4 class="font-bold text-lg mb-3 mt-6">Percent for Staff (%)</h4>
            <vs-input v-model="staff_percentage" class="w-full"/>
          </div>

          <div class="w-2/3 mx-auto">
            <vs-button class="w-full mt-base" @click="saveDiscountSetting">Save Setting</vs-button>
          </div>
        </div>
      </vs-tab>

      <vs-tab label="Cash Discount Setting">
        <div class="con-tab-ejemplo pt-base flex flex-col justify-between" style="min-height: inherit">
          <div>
            <h4 class="font-bold text-lg mb-3">Percent for Owner (%)</h4>
            <vs-input v-model="cash_owner_percentage" class="w-full" v-on:keypress="isIntegerNumber($event, 'cash-discount')" />

            <h4 class="font-bold text-lg mb-3 mt-6">Percent for Staff (%)</h4>
            <vs-input v-model="cash_staff_percentage" class="w-full"/>
          </div>

          <div class="w-2/3 mx-auto">
            <vs-button class="w-full mt-base" @click="saveCashDiscountSetting">Save Setting</vs-button>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>

<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
export default {
  name: 'vs-popup-setting-payroll',
  components: {
    'v-select': vSelect,
    Datepicker
  },
  props:{
    popupSettingPayroll: {
      type: Object,
    }
  },
  data() {
    let customPeriodOptions = [];
    for(let i = 1; i < 101; i++) {
      customPeriodOptions.push({id: i, label: `${i} day${i == 1 ? '' : 's'}`});
    }
    let customDay = customPeriodOptions[0];

    let periodOptions = [
      {id: 1, label: 'Week', value: 'week'},
      {id: 2, label: 'Two weeks', value: '2weeks'},
      {id: 3, label: 'Month', value: 'month'},
      {id: 4, label: 'Custom', value: 'custom'},
    ];
    let selectedPeriod = periodOptions[0];
    let start_date = null;
    // this.getPayrollSettingData();
    return {
      periodOptions,
      selectedPeriod,
      customPeriodOptions,
      customDay,
      // start_date: new Date(),
      start_date,
      owner_percentage: 0,
      staff_percentage: 100,
      cash_owner_percentage: 0,
      cash_staff_percentage: 100,
      action_type: '',
      isOpenLoading: false,
      active_tab: 0,
      utc_date: false,
    }
  },
  watch: {
    popupSettingPayroll: {
      immediate: true,
      deep: true,
      handler() {
        if(this.popupSettingPayroll.isOpen) {
          this.getPayrollSettingData();
          this.getDiscountSettingData();
          this.getCashDiscountSettingData();
          this.active_tab = 0;
        }
      }
    },
    payrollSetting: {
      immediate: true,
      deep: true,
      handler() {
        this.getPayrollSettingData();
      }
    },
    discountSetting: {
      immediate: true,
      deep: true,
      handler() {
        this.getDiscountSettingData();
      }
    },
    cashDiscountSetting: {
      immediate: true,
      deep: true,
      handler() {
        this.getCashDiscountSettingData();
      }
    },
    owner_percentage: {
      immediate: true,
      handler() {
        this.staff_percentage = 100 - this.owner_percentage;
      }
    },
    staff_percentage: {
      immediate: true,
      handler() {
        this.owner_percentage = 100 - this.staff_percentage;
      }
    },
    cash_owner_percentage: {
      immediate: true,
      handler() {
        this.cash_staff_percentage = 100 - this.cash_owner_percentage;
      }
    },
    cash_staff_percentage: {
      immediate: true,
      handler() {
        this.cash_owner_percentage = 100 - this.cash_staff_percentage;
      }
    },
  },
  methods: {
    getUtc() {
      let date = new Date();
      if (date.getTimezoneOffset() < 0) {
        this.utc_date = true;
      } else {
        this.utc_date = false;
      }
      console.log(this.utc_date);
    },
    openLoadingInDiv(){
        this.$vs.loading({
            container: '#app',
            scale: 0.8
        })
        if(this.loadTime){
            clearTimeout(this.loadTime);
            this.loadTime = null;
        }
        this.isOpenLoading = true;
        this.loadTime = setTimeout( ()=> {
            if(this.isOpenLoading) {
            this.closeLoading();
            this.$vs.dialog({
                color: 'danger',
                title: 'Notification',
                text: this.action_type + ' failed',
                acceptText: 'OK'
            })
            }
        }, 10000);

    },
    closeLoading() {
        this.$vs.loading.close('#app > .con-vs-loading');
        this.isOpenLoading = false;
    },
    isIntegerNumber: function(evt, type) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
        } else {
          if(type == 'discount') {
            if(parseInt(this.owner_percentage + '' + evt.key) <= 100) {
                return true;
            } else {
                evt.preventDefault();
            }
          } else {
            if(parseInt(this.cash_owner_percentage + '' + evt.key) <= 100) {
                return true;
            } else {
                evt.preventDefault();
            }
          }
        }
    },
    getPayrollSettingData() {
      if(this.payrollSetting && this.payrollSetting != {}) {
        if(this.payrollSetting.period) {
          for(let i = 0; i < this.periodOptions.length; i++) {
            if(this.periodOptions[i].value == this.payrollSetting.period) {
              this.selectedPeriod = this.periodOptions[i];
            }
          }
          if(this.payrollSetting.period == 'custom' && this.payrollSetting.custom_days > 0) {
            let custom_days = this.payrollSetting.custom_days;
            this.customDay = { id: custom_days, label: `${custom_days} day${custom_days == 1 ? '' : 's'}` };
          } else {
            this.customDay = this.customPeriodOptions[0];
          }
        }

        if(this.payrollSetting.start_date) {
          this.start_date = this.payrollSetting.start_date;
        }
      }
    },
    getDiscountSettingData() {
      if(this.discountSetting && this.discountSetting != {}) {
        this.owner_percentage = parseInt(this.discountSetting.owner_percentage * 100);
        this.staff_percentage = parseInt(this.discountSetting.staff_percentage * 100);
      }
    },
    getCashDiscountSettingData() {
      if(this.cashDiscountSetting && this.cashDiscountSetting != {}) {
        this.cash_owner_percentage = parseInt(this.cashDiscountSetting.owner_percent * 100);
        this.cash_staff_percentage = parseInt(this.cashDiscountSetting.staff_percent * 100);
      }
    },
    savePayrollSetting() {
      this.getUtc();
      if(this.utc_date == false && this.start_date != null){
        this.start_date = new Date(
          new Date(this.start_date).getFullYear(),
          new Date(this.start_date).getMonth(),
          new Date(this.start_date).getDate() + 1
        )
      }
      let data = {
        period: this.selectedPeriod.value,
        payday: this.start_date == null ? '' : moment(this.start_date).format('YYYY-MM-DD')
      }
      if(this.selectedPeriod.value == 'custom') {
        data.custom_days = this.customDay.id;
      }
      // if(this.start_date != null && this.start_date != "") {
      //   data.payday = moment(this.start_date).format('YYYY-MM-DD');
      // }
      this.$emit('UpdatePayrollSetting', data);
      // this.action_type = "Update payroll setting";
      // if(!this.isOpenLoading) {
      //   this.openLoadingInDiv();
      // }
      // this.$store.dispatch('goPos/UPDATE_PAYROLL_SETTING', data).then(() => {
      //   this.popupSettingPayroll.isOpen = false;
      //   this.closeLoading();
      //   this.$vs.notify({
      //     title:'Notification',
      //     text: this.action_type + ' success',
      //     color: 'success',
      //     position:'top-right'});
      // }).catch((err) => {
      //   console.log('Err: ' + err);
      //   this.popupSettingPayroll.isOpen = false;
      // })
    },
    saveDiscountSetting() {
      let data = {
        owner_percent: this.owner_percentage / 100,
        staff_percent: this.staff_percentage / 100
      }
      this.$emit('UpdateDiscountSetting', data);
    },
    saveCashDiscountSetting() {
      let data = {
        owner_percent: this.cash_owner_percentage / 100,
        staff_percent: this.cash_staff_percentage / 100
      }
      this.$emit('UpdateCashDiscountSetting', data);
    }
  },
  computed: {
    payrollSetting() {
      return this.$store.getters["goPos/payrollSetting"];
    },
    discountSetting() {
      return this.$store.getters["goPos/discountSetting"];
    },
    cashDiscountSetting() {
      return this.$store.getters["goPos/cashDiscountSetting"];
    }
  }
}
</script>
